<script lang="ts" setup>
	import {vAutoAnimate} from '@formkit/auto-animate';
	import {FormElementBase, Variable} from '@/scripts/types/generated';

	const $props = withDefaults(
		defineProps<
			Partial<
				FormElementBase & {
					columns?: number;
					name?: string;
					disabled?: boolean;
					variableVersionUuid?: string;
					variable?: Variable;
				}
			>
		>(),
		{
			columns: null,
		}
	);

	defineOptions({
		inheritAttrs: false,
	});
</script>

<template>
	<FormItem
		v-if="$props.category === 'field'"
		v-auto-animate
		v-bind="$attrs"
	>
		<FormLabel v-if="$props.label">{{ $props.label }}</FormLabel>
		<slot />
		<FormDescription v-if="$props.description">
			{{ $props.description }}
		</FormDescription>
		<FormMessage />
	</FormItem>
	<FormItem
		v-else
		v-bind="$attrs"
	>
		<Label v-if="$props.label">{{ $props.label }}</Label>
		<slot />
		<Description v-if="$props.description"
			>{{ $props.description }}
		</Description>
	</FormItem>
</template>
